/** @file PoseInput of the stores: what currentPoseAt shows (W3-30) plus the drag previews by data index. */
import type { SkeletonData } from '@pose2d/core/types';
import { currentPoseAt } from '../../playback/currentPoseAt';
import type { RuntimeState } from './runtimeState';
import type { PreviewValues } from './scene/channelOffset';
import type { PoseInput } from './scene/poseScene';

/** R-E1-04 through currentPoseAt (mix, else the playhead in Animate mode, else setup); unknown bones are dropped. */
export function poseInputOf(s: Pick<RuntimeState, 'preview' | 'maps'>, data: SkeletonData): PoseInput {
  const preview = new Map<number, PreviewValues>();
  for (const [id, values] of s.preview) {
    const i = s.maps?.boneIndex.get(id);
    if (i !== undefined) preview.set(i, values);
  }
  return { at: currentPoseAt(data), preview };
}
